// Generated by ReScript, PLEASE EDIT WITH CARE


function getRnrHome(param) {
  return {
          pointsSectionTitle: "ಒಟ್ಟು ರಿವಾರ್ಡ್ ಅಂಕಗಳು",
          pointsSectionSubtitle: "ಹೊಸ ಹಂತಗಳನ್ನು ತಲುಪಿ ಅತ್ಯಾಕರ್ಷಕ ಉಡುಗೊರೆಗಳನ್ನು ಗೆಲ್ಲಿರಿ",
          dailyRewardsHeader: "ದಿನದ ರಿವಾರ್ಡ್ಸ್",
          cardCtaText: "ಪಡೆದುಕೊಳ್ಳಲು ಟ್ಯಾಪ್ ಮಾಡಿ",
          allRewardsClaimedTitle: "ಅಭಿನಂದನೆಗಳು",
          allRewardsClaimedText: "ನೀವು ಎಲ್ಲಾ ರಿವಾರ್ಡ್ ಗಳನ್ನು ಪಡೆದುಕೊಂಡಿದ್ದೀರಿ",
          noRewardsClaimedTitle: "ನಿಮ್ಮ ಬಳಿ ಈಗ ಯಾವುದೇ ರಿವಾರ್ಡ್ಸ್ ಗಳಿಲ್ಲ",
          noRewardsClaimedText: "ದಯವಿಟ್ಟು ನಾಳೆ ಮತ್ತೆ ಪರಿಶೀಲಿಸಿ",
          rewardHistoryFooterText: "ಬಹುಮಾನಗಳು ಮತ್ತು ಉಡುಗೊರೆಗಳ ಇತಿಹಾಸ",
          headerText: "ಪೋರ್ಟರ್ ರಿವಾರ್ಡ್ಸ್ ಕಾರ್ಯಕ್ರಮ"
        };
}

function getMilestoneDetails(vehicleModel) {
  return {
          headerTitle: "ಗೆಲ್ಲಿರಿ " + vehicleModel,
          headerDetails: "ಹೆಚ್ಚಿನ ರಿವಾರ್ಡ್ ಪಾಯಿಂಟ್ ಗಳನ್ನು ಪಡೆದ ಪಾಲುದಾರ ಈ ಹೊಸ ಟ್ರಕ್ ಅನ್ನು ಗೆಲ್ಲುತ್ತಾನೆ",
          claimedText: "ಪಡೆದುಕೊಂಡ ರಿವಾರ್ಡ್ಸ್",
          toClaimText: "ನಿಮ್ಮ ರಿವಾರ್ಡ್ ಅನ್ನು ಪಡೆದುಕೊಳ್ಳಿ",
          footerText: "ನಿಮ್ಮ ಪ್ರಗತಿಯು ಹೆಚ್ಚಿನ ಲೇವೇಲನ್ನು ಅನ್ಲಾಕ್ ಮಾಡುತ್ತದೆ",
          milestone1: "ಸ್ಟಾರ್",
          milestone2: "ಬ್ರೊನ್ಜ್ ಹೀರೋ",
          milestone3: "ಬ್ರೊನ್ಜ್ ಸೂಪರ್ ಸ್ಟಾರ್",
          milestone4: "ಸಿಲ್ವರ್ ಹೀರೋ",
          milestone5: "ಸಿಲ್ವರ್ ಸೂಪರ್ ಸ್ಟಾರ್",
          milestone6: "ಪ್ಲಾಟಿನಂ ಹೀರೋ",
          milestone7: "ಪ್ಲಾಟಿನಂ ಸೂಪರ್ ಸ್ಟಾರ್",
          milestone8: "ಗೋಲ್ಡ್ ಹೀರೋ",
          milestone9: "ಗೋಲ್ಡ್ ಸೂಪರ್ ಸ್ಟಾರ್",
          milestone10: "ಡೈಮಂಡ್ ಹೀರೋ",
          milestone11: "ಡೈಮಂಡ್ ಸೂಪರ್ ಸ್ಟಾರ್",
          milestone12: "ಪೋರ್ಟರ್ ಹೀರೋ",
          milestone13: "ಸುಪ್ರೊ ಸೂಪರ್ ಸ್ಟಾರ್",
          locked: "ಲಾಕ್ ಮಾಡಲಾಗಿದೆ"
        };
}

function getRnrCycleEnd(param) {
  return {
          greetings: " ಅಭಿನಂದನೆಗಳು ",
          winLabel: " ನೀವು ಗೆದ್ದಿದ್ದೀರಿ ಒಂದು ",
          winNotice: " ಬಹುಮಾನವನ್ನು ಹೇಗೆ ಪಡೆದುಕೊಳ್ಳುವುದು ಎಂಬುದರ ಕುರಿತು ನಾವು ನಿಮಗೆ ಕರೆ ಮಾಡಿ ತಿಳಿಸುತ್ತೇವೆ ",
          lossNotice: " ಕ್ಷಮಿಸಿ. ಈ ಬಾರಿ ನೀವು ಯಾವುದೇ ಬಹುಮಾನವನ್ನು ಗೆದ್ದಿಲ್ಲ. ಬಹುಮಾನ ಗೆಲ್ಲಲು ದಯವಿಟ್ಟು ಮುಂದಿನ ಸುತ್ತಿನಲ್ಲಿ  ಉತ್ತಮವಾಗಿ ಭಾಗವಹಿಸಿ. ",
          endTitle: " ಪೋರ್ಟರ್ ರಿವಾರ್ಡ್ ಪ್ರೋಗ್ರಾಂ ಕೊನೆಗೊಂಡಿದೆ. ",
          endText: " ಮುಂದಿನ ಸುತ್ತಿನ ಬಗ್ಗೆ  ಶೀಘ್ರದಲ್ಲೇ ಘೋಷಿಸಲಾಗುವುದು. ",
          scoreTitle: " ನೀವು ಹೇಗೆ ಪ್ರದರ್ಶನ ನೀಡಿದ್ದೀರಿ ಎಂಬುದು ಇಲ್ಲಿದೆ ",
          totalScoreSubtext: " ಒಟ್ಟು ಅಂಕಗಳು ",
          customerExperienceScoreSubtext: " ಗ್ರಾಹಕರ ಸೇವೆಗಾಗಿ ",
          orderCompletionScoreSubtext: " ಆರ್ಡರ್ ಪೂರ್ಣಗೊಳಿಸುವಿಕೆಗಾಗಿ ",
          loginActivityScoreSubtext: " ಲಾಗಿನ್ ಚಟುವಟಿಕೆಗಾಗಿ ",
          topGiftsTitle: " ಪಾಲುದಾರರು ಗೆದ್ದಿರುವ ರೋಚಕ ಬಹುಮಾನಗಳು ಇಲ್ಲಿವೆ ",
          topPartnersTitle: " ನಮ್ಮ ಕೆಲವು ಉನ್ನತ ಪಾಲುದಾರರ ಪಟ್ಟಿ ",
          partnerName: " ಪಾಲುದಾರರ ಹೆಸರು ",
          awardTitle: " ಗೆದ್ದಿರುವ ಬಹುಮಾನ "
        };
}

function getContent(param) {
  return {
          rnrHome: getRnrHome(undefined),
          rnrHistory: {
            title: "ರಿವಾರ್ಡ್ಸ್",
            yesterdayRowTitle: "ನಿನ್ನೆ",
            rewardNavTabTitle: "ದಿನದ ರಿವಾರ್ಡ್ಸ್",
            awardNavTabTitle: "ಹಂತದ ಉಡುಗೊರೆ ಗಳು"
          },
          milestoneDetails: getMilestoneDetails("Mahindra"),
          customerServiceRewards: {
            text1: "ನಿಮ್ಮ ಗಳಿಕೆ",
            text2: "ಉತ್ತಮ ಗ್ರಾಹಕರ ಸೇವೆಗಾಗಿ"
          },
          loginActivtyRewards: {
            text1: "ನಿಮ್ಮ ಗಳಿಕೆ",
            text2: "ಲಾಗ್ ಇನ್ ಚಟುವಟಿಕೆ"
          },
          orderFulfillmentRewards: {
            text1: "ನೀವು ಗಳಿಸಿದ್ಧೀರಿ",
            text2: "ಸ್ವೀಕರಿಸಿದ ಆರ್ಡರ್ ಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ್ಧಕ್ಕೆ"
          },
          mahindraAwards: {
            cardTitle: "ಗೆಲ್ಲಿರಿ ಮಹಿಂದ್ರಾ",
            cardText: "ಇನ್ನಷ್ಟು ತಿಳಿಯಲು ಟ್ಯಾಪ್ ಮಾಡಿ",
            modalTitle: "ಗೆಲ್ಲಿರಿ ಮಹಿಂದ್ರಾ",
            modalText: "ಮಹೀಂದ್ರಾ ಸುಪ್ರೋ ಬಹುಮಾನವನ್ನು ಗೆಲ್ಲಿರಿ ಮತ್ತು ಪ್ರತಿ ತಿಂಗಳು ಅತ್ಯಾಕರ್ಷಕ ಉಡುಗೊರೆಗಳನ್ನು ನಿಮ್ಮದಾಗಿಸಿಕೊಳ್ಳಿ. ಇನ್ನಷ್ಟು ತಿಳಿದುಕೊಳ್ಳಲು ನಿಮ್ಮ ಅಂಕಗಳನ್ನು ಪರಿಶೀಲಿಸುತ್ತಿರಿ."
          },
          defaultLCVAward: {
            modalTitle: "ಈ ದೀಪಾವಳಿಯಲ್ಲಿ ಬಂಪರ್ ಬಹುಮಾನ ಮತ್ತು ಇತರ ಅತ್ಯಾಕರ್ಷಕ ಬಹುಮಾನಗಳನ್ನು ಗೆಲ್ಲುವ ಅವಕಾಶವನ್ನು ಪಡೆಯಿರಿ!!",
            modalText: ""
          },
          defaultHCVAward: {
            modalTitle: "ಈ ದೀಪಾವಳಿಯಲ್ಲಿ ಬಂಪರ್ ಬಹುಮಾನ ಮತ್ತು ಇತರ ಅತ್ಯಾಕರ್ಷಕ ಬಹುಮಾನಗಳನ್ನು ಗೆಲ್ಲುವ ಅವಕಾಶವನ್ನು ಪಡೆಯಿರಿ!!",
            modalText: ""
          },
          default2WAward: {
            modalTitle: "ಪ್ರತಿ ವಾರ ಅತ್ಯಾಕರ್ಷಕ ಬಹುಮಾನಗಳನ್ನು ಗೆಲ್ಲಿರಿ.",
            modalText: ""
          },
          noAward: {
            cardTitle: "ಬಹುಮಾನ ಪಡೆಯಲು ಮುಂದಿನ ಮೈಲಿಗಲ್ಲನ್ನು ವೇಗವಾಗಿ ತಲುಪಿ!",
            cardText: "ನೀವು ಗೆಲ್ಲುವ ಬಹುಮಾನಗಳನ್ನು ಇತರ ಪಾಲುದಾರರು ಕ್ಲೈಮ್ ಮಾಡಿದ್ದಾರೆ",
            modalTitle: "ಬಹುಮಾನ ಪಡೆಯಲು ಮುಂದಿನ ಮೈಲಿಗಲ್ಲನ್ನು ವೇಗವಾಗಿ ತಲುಪಿ!",
            modalText: "ನೀವು ಗೆಲ್ಲುವ  ಬಹುಮಾನಗಳನ್ನು ಇತರ ಪಾಲುದಾರರು ಕ್ಲೈಮ್ ಮಾಡಿದ್ದಾರೆ. ಬಹುಮಾನ ಪಡೆಯಲು ದಯವಿಟ್ಟು ಮುಂದಿನ ಮೈಲಿಗಲ್ಲನ್ನು ವೇಗವಾಗಿ ತಲುಪಿ."
          },
          insuranceAward: {
            cardTitle: "ವಾಹನ ಇನ್ಶೂರೆನ್ಸ್ ಮೇಲೆ ನೀವು ರಿಯಾಯಿತಿ ಗಳಿಸಿದ್ದೀರಿ",
            modalTitle: "ಹುರ್ರೇ !!ವಾಹನ ಇನ್ಶೂರೆನ್ಸ್ ಮೇಲೆ ನೀವು ರಿಯಾಯಿತಿ ಗಳಿಸಿದ್ದೀರಿ"
          },
          distributionCeremonyAward: {
            cardTitle: "ಪೋರ್ಟರ್‌ನಿಂದ ಆಕರ್ಷಕ ಬಹುಮಾನಗಳನ್ನು ಗೆಲ್ಲುವ ಅವಕಾಶವನ್ನು ನೀವು ಹೊಂದಿದ್ದೀರಿ",
            cardText: "ಉನ್ನತ ಪ್ರದರ್ಶನ ನೀಡುವ ಪಾರ್ಟ್ನರ್ಸ್ ಗಳು ಆಕರ್ಷಕ ಬಹುಮಾನಗಳನ್ನು ಸ್ವೀಕರಿಸುತ್ತಾರೆ. ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತು ಗಳು ಅನ್ವಯಿಸುತ್ತದೆ",
            modalTitle: "ಪೋರ್ಟರ್‌ನಿಂದ ಆಕರ್ಷಕ ಬಹುಮಾನಗಳನ್ನು ಗೆಲ್ಲುವ ಅವಕಾಶವನ್ನು ನೀವು ಹೊಂದಿದ್ದೀರಿ",
            modalText: "ಉನ್ನತ ಪ್ರದರ್ಶನ ನೀಡುವ ಪಾರ್ಟ್ನರ್ಸ್ ಗಳು ಆಕರ್ಷಕ ಬಹುಮಾನಗಳನ್ನು ಸ್ವೀಕರಿಸುತ್ತಾರೆ. ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತು ಗಳು ಅನ್ವಯಿಸುತ್ತದೆ"
          },
          finalAward: {
            cardTitle: "ಪೋರ್ಟರ್‌ನಿಂದ \"ಮಹೀಂದ್ರಾ ಸುಪ್ರೋ\" ವಾಹನವನ್ನು ಗೆಲ್ಲುವ ಅವಕಾಶವನ್ನು ನೀವು ಹೊಂದಿದ್ದೀರಿ",
            cardText: "ಭಾರತದಾದ್ಯಂತ ಉನ್ನತ ಪ್ರದರ್ಶನ ಒಬ್ಬ ಪಾರ್ಟ್ನರ್ ಈ ಬಹುಮಾನವನ್ನು ಗ್ಗೆಲುತ್ತಾರೆ",
            modalTitle: "ಪೋರ್ಟರ್‌ನಿಂದ \"ಮಹೀಂದ್ರಾ ಸುಪ್ರೋ\" ವಾಹನವನ್ನು ಗೆಲ್ಲುವ ಅವಕಾಶವನ್ನು ನೀವು ಹೊಂದಿದ್ದೀರಿ",
            modalText: "ಭಾರತದಾದ್ಯಂತ ಉನ್ನತ ಪ್ರದರ್ಶನ ಒಬ್ಬ ಪಾರ್ಟ್ನರ್ ಈ ಬಹುಮಾನವನ್ನು ಗೇಲುತ್ತಾರೆ. ಕಾರ್ಯಕ್ರಮದ ಕೊನೆಯಲ್ಲಿ ವಿಜೇತರನ್ನು ಘೋಷಿಸಲಾಗುವುದು.ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತು ಗಳು ಅನ್ವಯಿಸುತ್ತದೆ"
          },
          couponAward: {
            couponText: "ಕೂಪನ್",
            redeemTitle: "ರಿಡೀಮ್ ಮಾಡುವ ವಿಧಾನ",
            detailsText: "ವಿವರಗಳು",
            tncText: "ನಿಯಮ ಮತ್ತು ಶರತ್ತುಗಳು",
            codeAckTitle: "ಕೂಪನ್ ಕೋಡ್ ಕಾಪಿ ಮಾಡಲಾಗಿದೆ"
          },
          status: {
            loading: "ಲೋಡಿಂಗ್",
            internetNotConnected: "ಇಂಟರ್ನೆಟ್ ಲಭ್ಯವಿಲ್ಲ",
            tapToRetry: "ಮರುಪ್ರಯತ್ನಿಸಲು ಟ್ಯಾಪ್ ಮಾಡಿ",
            ise: "ಏನೋ ಸರಿಯಾಗಿಲ್ಲ",
            loadingFailed: "ಲೋಡಿಂಗ್ ವಿಫಲವಾಗಿದೆ"
          },
          category: {
            customerService: "ಗ್ರಾಹಕರ ಸೇವೆ",
            loginHours: "ಲಾಗ್ ಇನ್ ಚಟುವಟಿಕೆ",
            orderFulfillment: "ಪೂರ್ಣಗೊಂಡ ಆರ್ಡರ್ ಗಳು"
          },
          customerServiceDetails: {
            details1: "ನೀವು ಮಾಡಿದ ಆರ್ಡರ್ ಗೆ ಗ್ರಾಹಕರು 5 ಸ್ಟಾರ್ ರೇಟಿಂಗ್ ನೀಡುವುದರಿಂದ, ನಿಮ್ಮ ಗ್ರಾಹಕ ಸೇವಾ ಪಾಯಿಂಟ್ ಗಳು ಹೆಚ್ಚಾಗುತ್ತದೆ",
            details2: "ಆದ್ದರಿಂದ, ನೀವು ಮಾಡುವ 5 ಸ್ಟಾರ್ ರೇಟಿಂಗ್ ಆರ್ಡರ್ ಗಳ ಸಂಖ್ಯೆಯನ್ನು ಹೆಚ್ಚಿಸಿ.",
            sectionHeader: "5 ಸ್ಟಾರ್ ರೇಟಿಂಗ್ ಗಳನ್ನು ಪಡೆಯುವುದು ಹೇಗೆ?",
            tip1: "ಯಾವಾಗಲೂ ಗ್ರಾಹಕರನ್ನು ಗೌರವಿಸಿ ಮತ್ತು ಗ್ರಾಹಕರೊಂದಿಗೆ ಸಭ್ಯರಾಗಿರಿ",
            tip2: "ಗ್ರಾಹಕರೊಂದಿಗೆ ಎಂದಿಗೂ ವಾದಿಸಬೇಡಿ. ವಿವಾದಗಳ ಸಂದರ್ಭದಲ್ಲಿ ಕಾಲ್ ಸೆಂಟರ್ ನ ಸಹಾಯ ತೆಗೆದುಕೊಳ್ಳಿ.",
            tip3: "ಗ್ರಾಹಕರ ವಸ್ತುಗಳ ಮೇಲೆ ಕಾಳಜಿ ವಹಿಸಿ"
          },
          loginHourDetails: {
            details1: "ನೀವು ಹೆಚ್ಚು ಆನ್ ಲೈನ್ ಇದ್ದಷ್ಟು, ಹೆಚ್ಚು ಲಾಗಿನ್ ಆಕ್ಟಿವಿಟಿ ಪಾಯಿಂಟ್ಸ್ನಿ  ಗಳಿಸುತ್ತೀರ",
            tips: "ಸಲಹೆಗಳು",
            tip: "ನಿಮ್ಮ ಖಾಲಿ ಸಮಯದಲ್ಲಿ ಪೋರ್ಟರ್ ಗೆ ಹೆಚ್ಚು ಲಾಗಿನ್ ಮಾಡಿ, ಹೆಚ್ಚು ಸಂಪಾದಿಸಿ"
          },
          orderFulfillmentDetails: {
            details1: "ಪೂರ್ಣಗೊಂಡ ಆರ್ಡರ್ ಗಳ  ಅಂಕಗಳನ್ನು ಹೇಗೆ ಗಳಿಸಬಹುದು?",
            details2: "ನೀವು ಪೂರ್ಣಗೊಳಿಸಲು ಬಯಸುವ ಆರ್ಡರ್ ಅನ್ನು ಮಾತ್ರ  ಸ್ವೀಕರಿಸಿ",
            tip1: "ಆರ್ಡರ್ ಅನ್ನು  ಸ್ವೀಕರಿಸಿದ ನಂತರ ಯಾವುದೇ ಆರ್ಡರ್ ಅನ್ನು ಕ್ಯಾನ್ಸಲ್  ಮಾಡಬೇಡಿ",
            tip2: "ಆರ್ಡರ್ ಅನ್ನು ಕ್ಯಾನ್ಸಲ್ ಮಾಡಲು  ಗ್ರಾಹಕರನ್ನು ಎಂದಿಗೂ ಕೇಳಬೇಡಿ",
            slabTableText: "ಪೂರ್ಣಗೊಂಡ ಆರ್ಡರ್ ಗಳ ಅಂಕಗಳನ್ನು ಕೆಳಗೆ ತೋರಿಸಲಾಗಿದೆ",
            slabTableCol1: "ಪೂರ್ಣಗೊಂಡ ಆರ್ಡರ್ ಗಳು",
            slabTableCol2: "ಅಂಕಗಳು"
          },
          miscellaneous: {
            points: "ಪಾಯಿಂಟ್ಸ್"
          },
          rnrCycleEnd: getRnrCycleEnd(undefined),
          getExpiryDateTitle: (function (date) {
              return "ಅವಧಿ ಮುಗಿಯುವ ದಿನ " + date;
            }),
          getExpiringDateTitle: (function (date) {
              return "" + date + "  ರಂದು ಮುಕ್ತಾಯಗೊಳ್ಳುತ್ತಿದೆ";
            }),
          getExpiryHoursTitle: (function (hours) {
              return "" + hours + " ಗಂಟೆಯೊಳಗೆ ಮುಗಿಯುತ್ತದೆ";
            }),
          getCurrentMilestoneText: (function (currentMilestone) {
              return "ನೀವು " + currentMilestone;
            }),
          getNextMilestoneText: (function (points, nextMilestone) {
              return "" + nextMilestone + " ಆಗಲು " + points + " ಹೆಚ್ಚು ಗಳಿಸಿ";
            }),
          getCustomerServiceRewardsText: (function (qualifiedOrders) {
              return " " + qualifiedOrders + " ಫೈವ್ ಸ್ಟಾರ್  ಟ್ರಿಪ್ಸ್   ";
            }),
          getOrderFulfillmentRewardsText: (function (completedOrders, _requiredOrders) {
              return "ನೀವು " + completedOrders + " ಆರ್ಡರ್ ಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿದ್ದೀರಿ";
            }),
          getLoginActivtyRewardsText: (function (loginHours) {
              return "ಪುರಸ್ಕರಿತ ಲಾಗ್ ಇನ್ ಗಂಟೆಗಳು " + loginHours;
            }),
          getLoginRewardsDetailsText: (function (points) {
              return "ನಿಮ್ಮ ಬಳಿ " + points + " ಲಾಗಿನ್ ಆಕ್ಟಿವಿಟಿ ಪಾಯಿಂಟ್ಸ್ ಗಳಿವೆ ";
            }),
          getCustomerServiceRewardsDetailsText: (function (points) {
              return "ನಿಮ್ಮ ಬಳಿ " + points + " ಗ್ರಾಹಕರ ಸೇವಾ ಪಾಯಿಂಟ್ಸ್ ಗಳಿವೆ";
            }),
          getNextMilestoneSubText: (function (points) {
              return "" + points + " ಪಾಯಿಂಟ್ಸ್ ದೂರವಿದ್ದೀರ";
            }),
          getCustomerServicePer5StarOrderPoints: (function (points) {
              return "ಪ್ರತಿ 5 ಸ್ಟಾರ್ ಆರ್ಡರ್ ಗೆ ನೀವು " + points + " ಅಂಕಗಳನ್ನು ಪಡೆಯುತ್ತೀರಿ ";
            }),
          getLoginHourRewardsDetailsText: (function (startTime, endTime) {
              return " ನೀವು " + startTime + " ಇಂದ " + endTime + " ಪೋರ್ಟರ್ನಲ್ಲಿ ಆನ್ಲೈನ್ ಇದ್ದರೆ ನಿಮ್ಮ ಲಾಗಿನ್ ಆಕ್ಟಿವಿಟಿ ಪಾಯಿಂಟ್ಸ್  ಹೆಚ್ಚಾಗುತದ್ದೆ  ";
            }),
          getLoginHourRewardsLoginWindowTip: (function (startTime, endTime) {
              return "ನೀವು " + startTime + " ಗಂಟೆ ಇಂದ " + endTime + " ಗಂಟೆಯೊಳಗೆ ಹೆಚ್ಚು ಆನ್ಲೈನ್ ಇರಲು ಪ್ರಯತ್ನಿಸಿ";
            }),
          getLoginHourRewardsPerHourPointsTip: (function (points) {
              return " ಪ್ರತಿ ಗಂಟೆ ಲಾಗಿನ್ ಮಾಡಿದಕ್ಕೆ " + points + " ಪಾಯಿಂಟ್ಸ್. ಹೆಚ್ಚಿನ  ಲಾಗಿನ್, ಹೆಚ್ಚಿನ ಪಾಯಿಂಟ್ಸ್ ಗಳಿಕೆ  ";
            }),
          getOrderFullfillmentRewardsDetailsText: (function (points) {
              return "ನಿಮ್ಮ ಬಳಿ " + points + " ಪೂರ್ಣಗೊಂಡ ಆರ್ಡರ್ ಗಳ ಅಂಕಗಳಿವೆ";
            }),
          getOrderFullfillmentDailyMaxPointsTip: (function (points) {
              return "ನೀವು ದಿನಕ್ಕೆ " + points + " ಅಂಕಗಳನ್ನು ಮಾತ್ರ ಗಳಿಸಬಹುದು";
            }),
          getMilestonePointsRemaining: (function (points) {
              return " ಹೆಚ್ಚು ಅಗತ್ಯವಿರುವ ಅಂಕಗಳು " + points + " ";
            }),
          getLastSlabText: (function (orders) {
              return " " + orders + " ಅಥವಾ ಹೆಚ್ಚು ";
            }),
          getFuelAwardCardTitle: (function (fuelQuantity) {
              return " ನೀವು " + fuelQuantity + " ಲೀಟರ್ ಇಂಧನವನ್ನು ಗೆದ್ದಿದ್ದೀರಿ ";
            }),
          getFuelAwardCardText: (function (fuelMoney) {
              return " ನಿಮ್ಮ ವಾಲೆಟ್ ಗೆ " + fuelMoney + " ರೂ ಹಾಕಲಾಗಿದೆ ";
            }),
          getFuelAwardModalTitle: (function (fuelQuantity) {
              return " ಅಭಿನಂದನೆಗಳು ! ನೀವು " + fuelQuantity + " ಲೀಟರ್ ಇಂಧನವನ್ನು ಗೆದ್ದಿದ್ದೀರಿ ";
            }),
          getFuelAwardModalText: (function (fuelMoney) {
              return " ನಿಮ್ಮ ವಾಲೆಟ್ ಗೆ " + fuelMoney + " ರೂ ಸಮಾನ ಮೊತ್ತವನ್ನು ಹಾಕಲಾಗಿದೆ ";
            }),
          getPremiumnessAwardCardTitle: (function (acceptAdvantage) {
              return " ಆರ್ಡರ್ ನ ಸಮಯದಲ್ಲಿ " + acceptAdvantage + " ಸೆಕೆಂಡುಗಳ ವಿಳಂಬವಿಲ್ಲ! ";
            }),
          getPremiumnessAwardCardText: (function (acceptAdvantage, endDate) {
              return " ಆರ್ಡರ್ ಗಳ ಸಮಯದಲ್ಲಿ " + endDate + " ರವರೆಗೆ ನೀವು " + acceptAdvantage + " ಸೆಕೆಂಡುಗಳ ವಿಳಂಬವನ್ನು ಎದುರಿಸುವುದಿಲ್ಲ ";
            }),
          getPremiumnessAwardModalTitle: (function (acceptAdvantage) {
              return " ವಾವ್ !! ಆರ್ಡರ್ ಗಳ ಸಮಯದಲ್ಲಿ " + acceptAdvantage + " ಸೆಕೆಂಡುಗಳ ವಿಳಂಬವಿಲ್ಲ! ";
            }),
          getPremiumnessAwardModalText: (function (acceptAdvantage, startDate, endDate) {
              return " ನೀವು ಪೋರ್ಟರ್ ಪ್ರೀಮಿಯಂ ಪಾಲುದಾರ ಪ್ರಶಸ್ತಿಯನ್ನು ಗೆದ್ದಿದ್ದೀರಿ. ಇನ್ನು ಮುಂದೆ ಆರ್ಡರ್‌ಗಳಲ್ಲಿ ಕೆಳಗೆ ತಿಳಿಸಲಾದ ದಿನಾಂಕಗಳಲ್ಲಿ ನೀವು " + acceptAdvantage + " ಸೆಕೆಂಡುಗಳ ವಿಳಂಬವನ್ನು ಎದುರಿಸುವುದಿಲ್ಲ.\n        ಪ್ರಾರಂಭ ದಿನಾಂಕ - " + startDate + "\n        ಅಂತಿಮ ದಿನಾಂಕ - " + endDate + " ";
            }),
          getMonetaryAwardCardTitle: (function (amount) {
              return " ನೀವು ₹ " + amount + " ಗೆದ್ದಿದ್ದೀರಿ ";
            }),
          getMonetaryAwardCardText: (function (amount) {
              return " ₹ " + amount + " ಗೆದ್ದ ಬಹುಮಾನವನ್ನು ವಾಲೆಟ್ ಗೆ  ಸಲ್ಲಿಸಲಾಗಿದೆ ";
            }),
          getMonetaryAwardModalTitle: (function (amount) {
              return " ಹುರ್ರೇ !! ನೀವು ₹ " + amount + " ಗೆದ್ದಿದ್ದೀರಿ ";
            }),
          getMonetaryAwardModalText: (function (amount) {
              return " ₹ " + amount + " ಗೆದ್ದ ಬಹುಮಾನವನ್ನು ವಾಲೆಟ್ ಗೆ  ಸಲ್ಲಿಸಲಾಗಿದೆ ";
            }),
          getInsuranceAwardCardText: (function (price, endDate) {
              return " ನೀವು ಪೋರ್ಟರ್‌ನಿಂದ ₹" + price + " ರೂ ಗೆ  ಇನ್ಸೂರೆನ್ಸ್ಅನ್ನು  ಸಂಗ್ರಹಿಸಬಹುದು!! " + endDate + " ರವರೆಗೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ ";
            }),
          getInsuranceAwardModalText: (function (price, endDate) {
              return " ನೀವು ಪೋರ್ಟರ್‌ನಿಂದ ₹" + price + " ರೂ ಗೆ  ಇನ್ಸೂರೆನ್ಸ್ಅನ್ನು  ಸಂಗ್ರಹಿಸಬಹುದು!! " + endDate + " ರವರೆಗೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ ";
            }),
          getInsuranceAwardCardDiscountText: (function (discount, endDate) {
              return " ಪೋರ್ಟರ್‌ನಿಂದ ವಾಹನ ವಿಮೆಯಲ್ಲಿ ನೀವು ₹ " + discount + " ರಿಯಾಯಿತಿ ಗೆದ್ದಿದ್ದೀರಿ!! " + endDate + " ರವರೆಗೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ ";
            }),
          getInsuranceAwardModalDiscountText: (function (discount, endDate) {
              return " ಪೋರ್ಟರ್‌ನಿಂದ ವಾಹನ ವಿಮೆಯಲ್ಲಿ ನೀವು ₹ " + discount + " ರಿಯಾಯಿತಿ ಗೆದ್ದಿದ್ದೀರಿ!! " + endDate + " ರವರೆಗೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ ";
            }),
          getRewardMultiplierAwardCardTitle: (function (multiplier) {
              return " ನೀವು " + multiplier + " ರಿವಾರ್ಡ್  ಪಾಯಿಂಟ್ಸ್  ಗೆಲ್ಲುತ್ತೀರಿ ";
            }),
          getRewardMultiplierAwardCardText: (function (multiplier, startDate, endDate) {
              return " " + startDate + " ಇಂದ ಎಲ್ಲಾ ವಿಭಾಗಗಳು ನಿಮಗೆ " + multiplier + " ರಿವಾರ್ಡ್  ಪಾಯಿಂಟ್ಸ್ ನೀಡುತ್ತವೆ ಇದು " + endDate + " ರವರೆಗೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ ";
            }),
          getRewardMultiplierAwardModalTitle: (function (multiplier) {
              return " ಹುರ್ರೇ! ನೀವು " + multiplier + " ರಿವಾರ್ಡ್  ಪಾಯಿಂಟ್ಸ್  ಗೆಲ್ಲುತ್ತೀರಿ ";
            }),
          getRewardMultiplierAwardModalText: (function (multiplier, startDate, endDate) {
              return " " + startDate + " ಇಂದ ಎಲ್ಲಾ ವಿಭಾಗಗಳು ನಿಮಗೆ " + multiplier + " ರಿವಾರ್ಡ್  ಪಾಯಿಂಟ್ಸ್ ನೀಡುತ್ತವೆ ಇದು " + endDate + " ರವರೆಗೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ ";
            }),
          getTopGiftCardSubtext: (function (recipient_cnt) {
              return " " + recipient_cnt + " ಪಾಲುದಾರರಿಗೆ ನೀಡಲಾಗಿದೆ ";
            })
        };
}

var Kannada = {
  getContent: getContent
};

export {
  Kannada ,
  
}
/* No side effect */
